import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface DraftConversationParams {
  priority: string;
  status: "draft" | "open" | "solved" | "closed";
  text: string;
  title: string;
  type: "circle_bot" | "live_chat" | "email";
}

interface CreateDraftConversationOptions {
  onError?: (error: { errorDetails: string }) => void;
  onSuccess?: (data: { id: string }) => void;
}

export const useCreateDraftConversation = ({
  onSuccess,
  onError,
}: CreateDraftConversationOptions = {}) =>
  useMutation({
    mutationFn: async (params: DraftConversationParams) =>
      reactQueryPost(
        internalApi.supportWidget.createConversationDraftV2({
          conversation: {
            title: params.title,
            status: params.status,
            data: {
              type: params.type,
              text: params.text,
              priority: params.priority,
            },
          },
        }),
      ),
    onSuccess,
    onError,
  });
